import _ from "lodash";

export const trimKeyPrefix = (o: any, prefix: string, exceptions: string[] = []) => {
    const newObject = {};
    const length = prefix.length;
    Object.keys(o).forEach((key) => {
        let newKey = key;
        let value = o[key];
        if (key.substr(0, length) === prefix && !exceptions.includes(key)) {
            newKey = key.substring(length);
        }
        if (Array.isArray(value)) {
            value.forEach((item, idx) => {
                if (typeof item === "object" && item !== null) {
                    value[idx] = trimKeyPrefix(item, prefix, exceptions);
                }
            });
        } else if (typeof value === "object" && value !== null) {
            value = trimKeyPrefix(value, prefix, exceptions);
        }
        newObject[newKey] = value;
    });
    return newObject;
};

export const keyBy = (array = [], key = "") => {
    return array.reduce((obj, item) => {
        obj[item[key]] = item;
        return obj;
    }, {});
};

export const getUrlForNoSidePanel = (item, location) => {
    return `${location.pathname.replace(`/item/${item}`, "")}${location.search}`;
};

export const getSizesQuery = (ids) => ids.join("&_id=");

/*
 * Takes a key and trims __ or any prefix from front.
 *
 * @method trimKeyPrefixString
 *
 * @params {key} string - The value with prefix
 * @params {prefix} string - The value needs to be trimmed
 *
 * @returns {newKey} string - Trimmed value
 */
export const trimKeyPrefixString = (key: string, prefix: string) => {
    let newKey = key;
    const length = prefix.length;
    if (key.substr(0, length) === prefix) {
        newKey = key.substring(length);
    }
    return newKey;
};

/*
 * Search if multiple typekey (field.0, field.1) exists inside object.
 *
 * @method checkMultiTypeKeyExists
 *
 * @params {o} any - The object in which key needs to searched
 * @params {key} string - The value which needs to be searched
 *
 * @returns {result} boolean - True/False
 */
export const checkMultiTypeKeyExists = (o: any, key: string) => {
    return _.chain(o)
        .keys()
        .map((k) => _.first(k.split(".")))
        .some((value) => value === key)
        .value();
};
